module.exports = __webpack_public_path__ + "img/effects_bubble_motivation.cd618582.png";